/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon20Light = forwardRef('AttachLinkOffIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.854 1.146a.5.5 0 1 0-.708.708l15 15a.5.5 0 0 0 .708-.708l-1.783-1.783A5.5 5.5 0 0 0 13.5 4h-1.251a.5.5 0 0 0 0 1.001h1.25a4.5 4.5 0 0 1 1.823 8.616L11.707 10H14a.5.5 0 0 0 0-1h-3.293l-4-4H7.75a.5.5 0 0 0 0-1H6.5c-.252 0-.5.017-.743.05L2.854 1.146Z" }),
        React.createElement("path", { d: "M1 9.5c0-1.86.924-3.505 2.338-4.5l.72.72A4.5 4.5 0 0 0 6.5 14h1.25a.5.5 0 0 1 0 1H6.5A5.5 5.5 0 0 1 1 9.5Z" }),
        React.createElement("path", { d: "M6 9h1.338l1 1H6a.5.5 0 0 1 0-1Z" })));
});
